import { createLink, createSharedComposable, useI18n } from '#imports'
import type { LinkSchema } from '@core/types'

export const useLinks = createSharedComposable(() => {
    // Resolved once here: link getters also run from click handlers, outside any setup context.
    const { t } = useI18n()

    const frontpage = createLink(() => {
        return {
            to: {
                path: '/',
            },
        }
    })

    const signup = createLink(() => {
        return {
            to: {
                query: {
                    auth: 'signup',
                    step: '1',
                },
            },
        }
    })

    const login = createLink(() => {
        return {
            to: {
                query: {
                    auth: 'login',
                },
            },
        }
    })

    const forgotPassword = createLink(() => {
        return {
            to: {
                query: {
                    auth: 'forgot-password',
                },
            },
        }
    })

    const payments = createLink(() => {
        return {
            to: { path: t('pages.deposit') } as LinkSchema['to'],
            external: true
        }
    })

    const support = createLink(() => {
        return {
            to: { path: t('pages.customerSupport') } as LinkSchema['to'],
        }
    })

    return {
        frontpage,
        signup,
        login,
        forgotPassword,
        payments,
        support,
    }
})
